
import {Component, Prop, Vue} from "vue-property-decorator";

    @Component
    export default class YesNoCancelDialog extends Vue {
      @Prop({required: true}) headline: string;
      @Prop() text: string;
    }
